import type { ITermsAndConditionsProps } from "../../types";
import { Link } from "@mui/icons-material";
import { Box, Checkbox, FormGroup, IconButton, Typography, FormControlLabel } from "@mui/material";

export default function TermsAndConditions(props: ITermsAndConditionsProps) {
  const { text, isTerms, styles, handleCheckTerms, handleOpenFile } = props;

  return (
    <FormGroup sx={styles.group}>
      <FormControlLabel
        control={
          <Box sx={styles.wrapper}>
            <Checkbox checked={isTerms[0]} value={0} onChange={handleCheckTerms} />
          </Box>
        }
        label={
          <Typography>
            {text.termsText}
            <IconButton id="eula" onClick={handleOpenFile}>
              <Link />
            </IconButton>
          </Typography>
        }
        sx={styles.control}
      />

      <FormControlLabel
        control={
          <Box sx={styles.wrapper}>
            <Checkbox checked={isTerms[1]} value={1} onChange={handleCheckTerms} />
          </Box>
        }
        label={text.consentText}
        sx={styles.control}
      />

      <FormControlLabel
        control={
          <Box sx={styles.wrapper}>
            <Checkbox checked={isTerms[2]} value={2} onChange={handleCheckTerms} />
          </Box>
        }
        label={
          <Typography>
            {text.privacyPolicy}
            <IconButton id="pp" onClick={handleOpenFile}>
              <Link />
            </IconButton>
          </Typography>
        }
        sx={styles.control}
      />
    </FormGroup>
  );
}
